import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";

import {
  getSeats,
  getModalInfo as getModalInfoMain,
  cancelFactor as cancelFactorMain,
  saveReservation,
  addUser as addUserMain,
} from "../../services/reservation.ts";
import { getFilterMax } from "../../services/adminTourList";

import ReservationContext from "./ReservationContext";
import AuthenticationContext from "Authentication/AuthenticationContext";

const ModalContext = React.createContext({
  editModalData: {
    users: [
      {
        id: -1,
        fname: "",
        lname: "",
        mobile: "",
        codemelli: "",
      },
    ],
    AC: [
      {
        id: -1,
        title: "",
        cost: 0,
        tour_id: -1,
      },
    ],
    seats: [],
  },
  editModalDynamicData: {
    factorId: -1,
    tour: { id: -1, title: "", price: 0 },
    selectedUser: null,
    selectedEscort: [],
    tourDiscount: 0,
    tourPrice: 0,
    totalPrice: 0,
    trasportType: "",
    seats: [],
    SAC: [
      {
        id: -1,
        price: 0,
        discount: 0,
        totalPrice: 0,
      },
    ],
  },
  signupModalInfo: {
    firstname: "",
    lastname: "",
    code: "",
    phone: "",
  },
  modalTourId: -1,
  maxPrice: 0,
  modalTourId: 0,
  factorId: 0,
  editModal: false,
  searchData: {
    tours: [{ value: -1, label: "" }],
    users: [{ value: -1, label: "" }],
    payment: [
      { value: 0, label: "پرداخت نشده" },
      { value: 1, label: "بدهکار" },
      { value: 2, label: "پرداخت شده" },
    ],
  },
  selectedSearchData: {
    tourId: -1,
    userIds: [],
    paymentVal: -1,
  },
  payModalData: {
    factorId: 0,
    price: 0,
  },
  payModalDataHandler: (data) => {},
  updateModal: () => {},
  editModalChanger: (state) => {},
  SelectedSDHandler: (key, value) => {},
  SDHandler: (value) => {},
  MDataHandler: (key, value) => {},
  MDDataHandler: (key, value) => {},
  SMInfoHandler: (key, value) => {},
  getModalData: (id, type) => {},
  cancelFactor: async (id) => {},
  saveFactor: async (factorId) => {},
  resetModalDynamicData: () => {},
  undoneSignup: async () => {},
  changeTourId: (id) => {},
  changeFactorId: (id) => {},
  addUser: async () => {},
});

function ModalContextProvider({ children }) {
  const { userInfo } = useContext(AuthenticationContext);
  const { reservations, tours, getInfo, loadingHandler, getFactors } =
    useContext(ReservationContext);

  const [maxPrice, setMaxPrice] = useState(0);
  const [editModalData, setEditModalData] = useState({
    users: [
      {
        id: -1,
        fname: "",
        lname: "",
        mobile: "",
        codemelli: "",
      },
    ],
    AC: [
      {
        id: -1,
        title: "",
        cost: 0,
        tour_id: -1,
      },
    ],
    seats: [],
  });
  const [editModalDynamicData, setEditModalDynamicData] = useState({
    factorId: -1,
    tour: { id: -1, title: "", price: 0 },
    selectedUser: null,
    selectedEscort: [],
    tourDiscount: 0,
    tourPrice: 0,
    totalPrice: 0,
    trasportType: "",
    seats: [],
    SAC: [
      {
        id: -1,
        price: 0,
        discount: 0,
        totalPrice: 0,
      },
    ],
  });
  const [signupModalInfo, setSignupModalInfo] = useState({
    firstname: "",
    lastname: "",
    code: "",
    phone: "",
  });
  const [modalTourId, setModalTourId] = useState(-1);
  const [factorId, setFactorId] = useState(-1);
  const [editModal, setEditModal] = useState(false);
  const [modalUpdater, setModalUpdater] = useState(false);
  const [searchData, setSearchData] = useState({
    tours: [{ value: -1, label: "" }],
    users: [{ value: -1, label: "" }],
    payment: [
      { value: 0, label: "پرداخت نشده" },
      { value: 1, label: "بدهکار" },
      { value: 2, label: "پرداخت شده" },
    ],
  });
  const [selectedSearchData, setSelectedSearchData] = useState({
    tourId: -1,
    userIds: [],
    paymentVal: -1,
  });
  const [payModalData, setPayModalData] = useState({
    factorId: 0,
    price: 0,
  });

  function payModalDataHandler(data) {
    setPayModalData(data);
  }

  function updateModal() {
    setModalUpdater(!modalUpdater);
  }

  function editModalChanger(state) {
    setEditModal(state);
  }

  function searchDataHandler(value) {
    if (!Object.keys(value).includes("payment")) {
      value.payment = [
        { value: 0, label: "پرداخت نشده" },
        { value: 1, label: "بدهکار" },
        { value: 2, label: "پرداخت شده" },
      ];
    }
    setSearchData(value);
  }

  function selectedSearchDataHandler(key, value) {
    setSelectedSearchData({ ...selectedSearchData, [key]: value });
  }

  function editModalDataHandler(key, value) {
    setEditModalData({ ...editModalData, [key]: value });
  }

  function editModalDynamicDataHandler(key, value) {
    let data = { ...editModalDynamicData, [key]: value };
    if ("tourDiscount,selectedEscort,SAC".includes(key)) {
      let x = 0;
      data.SAC = data.SAC.map((value) => {
        let temp =
          (value.price - value.discount) * (data.selectedEscort.length + 1);
        x += temp;
        return {
          ...value,
          totalPrice: temp,
        };
      });
      let y =
        (data.tour.price - data.tourDiscount) *
        (data.selectedEscort.length + 1);
      data.tourPrice = y > 0 ? y : 0;
      data.totalPrice = data.tourPrice + x;
    }
    setEditModalDynamicData(data);
  }

  function signupModalInfoHandler(key, value, key1 = null, value1 = null) {
    let data = { ...signupModalInfo, [key]: value };
    if (key1 !== null) {
      data[key1] = value1;
    }
    setSignupModalInfo(data);
  }

  function changeTourId(id) {
    setModalTourId(id);
  }

  function changeFactorId(id) {
    setFactorId(id);
  }

  async function getModalData(id, type = 1) {
    loadingHandler(true);
    /* TYPES = {
        1: "edit",
        2: "save",
    } */
    if (id != -1) {
      switch (type) {
        case 1:
          let factor = reservations.find((factor) => factor.id == id);
          let discount = factor.additionalCost.reduce((total, ac) => {
            return total + ac.discount;
          }, 0);
          discount =
            factor.factor.total_discount / factor.factor.total_count - discount;
          let selectedSeats = [factor.buyer.seat_number].concat(
            factor.passangers.map((value) => value.seat_number)
          );
          setEditModalDynamicData({
            ...editModalDynamicData,
            factorId: id,
            tour: {
              id: factor.tour.id,
              title: factor.tour.title,
              price: factor.tour.mainprice,
            },
            selectedUser: {
              value: factor.buyer.id,
              label: `${factor.buyer.fullname} - ${factor.buyer.mobile}`,
            },
            selectedEscort: factor.passangers.map((passer) => {
              return {
                value: passer.id,
                label: `${passer.fullname} - ${passer.mobile}`,
              };
            }),
            tourDiscount: discount,
            tourPrice:
              (factor.tour.mainprice - discount) *
              (factor.passangers.length + 1),
            totalPrice: factor.factor.total_amt,
            trasportType: factor.tour.trasportType,
            seats: selectedSeats.map((value) => {
              return {
                value: value,
                label: `صندلی شماره ${value}`,
              };
            }),
            SAC: factor.additionalCost.map((ac) => {
              return {
                id: ac.id,
                price: ac.cost,
                discount: ac.discount,
                totalPrice: (ac.cost - ac.discount) * factor.factor.total_count,
              };
            }),
          });
          let theSeats = await getSeats(factor.tour.id);
          editModalDataHandler("seats", theSeats);
          break;
        case 2:
          let tour = tours.find((tour) => tour.id == id);
          let temp = await getSeats(tour.id);
          editModalDataHandler("seats", temp);
          setEditModalDynamicData({
            factorId: -1,
            tour: { id: tour.id, title: tour.title, price: tour.mainprice },
            selectedUser: null,
            selectedEscort: [],
            tourDiscount: 0,
            tourPrice: tour.mainprice,
            totalPrice: tour.mainprice,
            trasportType: tour.trasportType,
            seats: [],
            SAC: [
              {
                id: -1,
                price: 0,
                discount: 0,
                totalPrice: 0,
              },
            ],
          });
          break;
        default:
      }
    }
    loadingHandler(false);
  }

  async function saveFactor() {
    let data = {
      buyer: {
        id: -1,
        fname: "",
        lname: "",
        codemelli: "",
        mobile: "",
      },
      seats: [],
      passangers: [
        {
          id: -1,
          fname: "",
          lname: "",
          codemelli: "",
          mobile: "",
        },
      ],
      total_count: 0,
      total_discount: 0,
      total_amt: 0,
      total_paid: 0,
      tour_id: -1,
      additionalCosts: [
        {
          id: -1,
          discount: 0,
        },
      ],
    };

    loadingHandler(true);
    let user = editModalData.users.find(
      (user) => user.id == editModalDynamicData.selectedUser.value
    );
    if (typeof user === "undefined") {
      Swal.fire({
        title: "خطا!",
        text: "مشکلی در ثبت پیش آمده، لطفا مجددا امتحان کنید.",
        icon: "error",
      });
      loadingHandler(false);
      return false;
    }
    data.buyer = {
      id: user.id,
      fname: user.fname,
      lname: user.lname,
      mobile: user.mobile,
      codemelli: user.codemelli,
    };

    data.passangers = editModalDynamicData.selectedEscort.reduce(
      (total, value) => {
        let user = editModalData.users.find((user) => user.id == value.value);
        if (typeof user === "undefined") {
          return total;
        }
        let d = {
          id: user.id,
          fname: user.fname,
          lname: user.lname,
          mobile: user.mobile,
          codemelli: user.codemelli,
        };
        return [...total, d];
      },
      []
    );
    data.seats = editModalDynamicData.seats.map((value) => value.value);
    let discount = parseInt(editModalDynamicData.tourDiscount);
    data.additionalCosts = editModalDynamicData.SAC.map((value) => {
      discount += parseInt(value.discount);
      return {
        id: value.id,
        discount: value.discount,
      };
    });

    data.total_count = editModalDynamicData.selectedEscort.length + 1;
    data.total_discount = discount * data.total_count;
    data.total_amt = editModalDynamicData.totalPrice;
    data.tour_id = modalTourId;

    let factor = reservations.find(
      (val) => val.id == editModalDynamicData.factorId
    );
    if (typeof factor !== "undefined") {
      data.total_paid = factor.factor.total_paid;
    }

    let res = await saveReservation(
      data,
      editModalDynamicData.factorId,
      userInfo.id
    );
    if (res) {
      await getFactors();
      Swal.fire({
        title:
          editModalDynamicData.factorId > 0
            ? "رزرو با موفقیت آپدیت شد."
            : "رزرو با موفقیت انجام شد.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } else
      await Swal.fire({
        title: "خطا",
        text: "مشکلی در ذخیره سازی پیش آمده، لطفا بعدا امتحان کند.",
      });
    loadingHandler(false);
  }

  async function cancelFactor(id) {
    loadingHandler(true);
    Swal.fire({
      title: "آیا از لغو رزرو مطمئن هستید؟",
      icon: "warning",
      showConfirmButton: true,
      confirmButtonText: "بله",
      showCancelButton: true,
      cancelButtonText: "خیر",
    }).then(async (res) => {
      if (res.isConfirmed) {
        let result = await cancelFactorMain(id);
        if (!result) {
          await Swal.fire({
            title: "خطا!",
            text: "مشکلی در کنسل کردن رزرو صورت گرفته، لطفا بعدا تلاش کنید.",
            icon: "error",
          });
        }
        await getFactors();
      }
      loadingHandler(false);
    });
  }

  function resetModalDynamicData() {
    setEditModalDynamicData({
      factorId: -1,
      tour: { id: -1, title: "", price: 0 },
      selectedUser: null,
      selectedEscort: [],
      tourDiscount: 0,
      tourPrice: 0,
      totalPrice: 0,
      seats: [],
      SAC: [],
    });
  }

  async function addUser(flag = false) {
    if (flag) {
      await undoneSignup();
      return;
    }
    let info = signupModalInfo;
    if (
      ["firstname", "lastname", "code", "phone"].reduce((prevVal, value) => {
        if (prevVal) return prevVal;
        if (info[value] == "") return true;
      }, false)
    ) {
      Swal.fire({
        title: "لطفا نام، نام خانوادگی، کدملی و شماره تماس را وارد کنید.",
        icon: "error",
        customClass: {
          container: "zIndex2000",
        },
      });
      await undoneSignup();
      return;
    }
    if (!/^(\+98|0)?9\d{9}$/.test(info.phone)) {
      Swal.fire({
        title: "لطفا شماره تماس را به درستی وارد کنید.",
        icon: "error",
        customClass: {
          container: "zIndex2000",
        },
      });
      await undoneSignup();
      return;
    }
    if (!/^\d{10}$/.test(info.code)) {
      Swal.fire({
        title: "لطفا کد ملی را به درستی وارد کنید.",
        icon: "error",
        customClass: {
          container: "zIndex2000",
        },
      });
      await undoneSignup();
      return;
    }
    let res = await addUserMain({
      fname: info.firstname,
      lname: info.lastname,
      codemelli: info.code,
      mobile: info.phone,
    });
    if (!res) {
      Swal.fire({
        title: "مشکلی در ثبت اطلاعات بوجود آمده است.",
        icon: "error",
        customClass: {
          container: "zIndex2000",
        },
      });
      await undoneSignup();
      return;
    }
    await getModalInfo();
    let option = {
      value: res,
      label: `${info.firstname} ${info.lastname} - ${info.phone}`,
    };
    if (editModalDynamicData.selectedUser.value == -1) {
      editModalDynamicDataHandler("selectedUser", option);
    } else {
      let temp = editModalDynamicData.selectedEscort.map((value) => {
        if (value.value == -1) {
          return option;
        }
        return value;
      });
      editModalDynamicDataHandler("selectedEscort", temp);
    }
    Swal.fire({
      title: "مشخصات همراه ثبت شد.",
      icon: "success",
      customClass: {
        container: "zIndex2000",
      },
    });
    setSignupModalInfo({
      firstname: "",
      lastname: "",
      code: "",
      phone: "",
    });
  }

  async function undoneSignup() {
    if (
      editModalDynamicData.selectedUser !== null &&
      editModalDynamicData.selectedUser.value == -1
    ) {
      editModalDynamicDataHandler("selectedUser", null);
    } else {
      let temp = editModalDynamicData.selectedEscort.filter(
        (value) => value.value != -1
      );
      editModalDynamicDataHandler("selectedEscort", temp);
    }
    setSignupModalInfo({
      firstname: "",
      lastname: "",
      code: "",
      phone: "",
    });
  }

  async function getModalInfo() {
    let res = await getModalInfoMain();
    setEditModalData({
      users: res.users,
      AC: res.additionalCost,
      seats: [],
    });
  }

  useEffect(() => {
    async function loadPage() {
      let res;
      await getFactors();
      await getInfo();
      await getModalInfo();
      res = await getFilterMax();
      setMaxPrice(res);
      loadingHandler(false);
    }

    loadPage();
  }, []);

  useEffect(() => {
    if (factorId == -1) {
      getModalData(modalTourId, 2);
    } else {
      if (modalTourId != -1) {
        getModalData(factorId, 1);
      }
    }
  }, [modalTourId, modalUpdater, factorId]);

  return (
    <ModalContext.Provider
      value={{
        editModalData,
        editModalDynamicData,
        editModal,
        maxPrice,
        modalTourId,
        factorId,
        signupModalInfo,
        searchData,
        signupModalInfo,
        selectedSearchData,
        payModalData,
        payModalDataHandler,
        updateModal,
        editModalChanger,
        SelectedSDHandler: selectedSearchDataHandler,
        SDHandler: searchDataHandler,
        MDataHandler: editModalDataHandler,
        MDDataHandler: editModalDynamicDataHandler,
        SMInfoHandler: signupModalInfoHandler,
        getModalData,
        cancelFactor,
        saveFactor,
        resetModalDynamicData,
        undoneSignup,
        changeTourId,
        changeFactorId,
        addUser,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}

export default ModalContext;
export { ModalContextProvider };
